import React from 'react';
import { isEmpty } from 'ramda';
import DeltaBarChart from './DeltaBarChartCore';
import ChartSelection from '../ChartSelection';
import GenericTooltip from '../GenericTooltip';
import { NoChart } from '../NoContent';

export default ({ data, ...rest }) =>
  data && !isEmpty(data) ? (
    <ChartSelection>
      {selectionProps => (
        <React.Fragment>
          <DeltaBarChart data={data} {...selectionProps} {...rest} />
          {selectionProps.tooltipProps ? (
            <GenericTooltip
              bounds={{ width: rest.width, height: Infinity, padding: 10 }}
              {...selectionProps.tooltipProps}
            />
          ) : null}
        </React.Fragment>
      )}
    </ChartSelection>
  ) : (
    <NoChart />
  );



// WEBPACK FOOTER //
// ./src/components/DeltaBarChart/DeltaBarChart.jsx